<template>
  <div>
    <span>{{ $t('massBalance.modalStep.selectAnalysis') }}</span>
    <div
      :class="`${massBalanceType === STEAM ? 'boilerAnalysis' : 'd-flex'}`"
    >
      <div
        v-for="(section, sectionIndex) in analysisSections"
        :key="sectionIndex"
        :class="{isNotLast: sectionIndex === 0 && analysisSections.length === 2}"
      >
        <div>
          <span
            v-if="section !== NONE"
            :class="{boilerAnalysisTitle:true, invalid: !isSectionValid(section)}"
          >{{ $t(`massBalance.modalStep.${section.toLowerCase()}`) }} <span>*</span></span>
          <div :class="`${section === NONE ? 'boilerAnalysisNoSome' : 'boilerAnalysisSome'}`">
            <VCheckbox
              v-for="(selectedAnalysis, selectedAnalysisIndex) in finalisedAnalysisSelection[section]"
              :key="selectedAnalysisIndex"
              v-model="selectedAnalisysType"
              :class="{checkStyle: true, invalid: !isSectionValid(section)}"
              :value="selectedAnalysis"
              :label="`${selectedAnalysis.name[userLang]} (${selectedAnalysis.measureUnit[userLang]})`"
              @change="emitChange"
            />
          </div>
          <span
            v-if="!isSectionValid(section)"
            :class="{ errorMessage: true, invalid: !isSectionValid(section)}"
          >{{ $t("massBalance.modalStep.errorMessage") }} <span>*</span></span>
        </div>
      </div>
    </div>
    <div
      v-for="(analysisSelected, analysisIndex) in analysisSelection"
      :key="analysisIndex"
      class="flowMeterType"
    >
      <div v-if="isIncludeAnalysisSelected(analysisSelected)">
        <div
          v-for="(flo, flowMeterIndex ) in allFlowMeterType"
          :key="flowMeterIndex"
        >
          <div v-if="sectionShow[getKey(flo, analysisSelected)]">
            <!--      if checked AnalysisType-->
            <div
              class="d-flex align-center mLeft"
              @click="showData(flo, analysisSelected)"
            >
              <v-icon
                v-if="show[getKey(flo, analysisSelected)]"
                large
                color="primary"
              >
                mdi-menu-down
              </v-icon>
              <v-icon
                v-else
                large
                color="primary"
              >
                mdi-menu-right
              </v-icon>
              <div class="typeLabel">
                <span>{{
                  $t(`massBalance.modalStep.${flo.type === TYPE_STEAM ? BOILER.toLowerCase() : flo.type.toLowerCase()}`)
                }}</span>
                <span>{{ `${analysisSelected.name[userLang]} (${analysisSelected.measureUnit[userLang]})` }}</span>
              </div>
            </div>
            <div :class="{hide: !show[getKey(flo, analysisSelected)]}">
              <div
                v-for="(floData, floDataIndex) in data[flo.type][analysisSelected.key]"
                :key="floDataIndex"
              >
                <VSelect
                  v-model="floData.networkId"
                  :label="$t('massBalance.modalStep.network')"
                  itemText="name"
                  itemValue="id"
                  :rules="{ required: true }"
                  outlined
                  :items="getAvailableNetworks(flo, analysisSelected, floData.networkId)"
                  @input="debouncedAnalysisComponent(floData, analysisSelected, flo)"
                  @change="emitChange"
                />
                <VAutocomplete
                  v-model="floData.componentIds"
                  :label="$t('massBalance.modalStep.component')"
                  :items="listComponentByNetwork[getKey(flo, analysisSelected)][floData.networkId]"
                  :rules="{ required: true }"
                  outlined
                  :multiple="true"
                  @input="onInput"
                  @change="emitChange"
                />
                <div
                  v-if="data[flo.type][analysisSelected.key].length > 1"
                  class="delStyleContent"
                  @click="removeReportData(analysisSelected.key, flo.type, floDataIndex)"
                >
                  <div class="delStyleContentDel">
                    <v-icon
                      color="white"
                      size="20"
                    >
                      delete
                    </v-icon>
                  </div>
                  <div>
                    {{ $t('massBalance.delete') }}
                  </div>
                </div>

                <div class="actionStyle">
                  <div
                    class="subBarre"
                  />
                  <div
                    v-if="floDataIndex === data[flo.type][analysisSelected.key].length - 1"
                    class="addStyle"
                    @click="()=>addReportData(analysisSelected.key, flo.type)"
                  >
                    <div class="addStyleContent">
                      <v-icon
                        color="white"
                        size="20"
                      >
                        add
                      </v-icon>
                    </div>
                    <div>
                      {{ $t('massBalance.add') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import { cloneDeep, debounce, isEmpty } from 'lodash';
import { COOLING, STEAM } from '@/aquassist-shared/constants/types/network';
import { CYCLES_OF_CONCENTRATION, MAKEUP_PERCENTAGE, NONE } from '@/aquassist-shared/constants/massBalance';
import { TYPE_FEED, TYPE_MAKE_UP, TYPE_STEAM } from '@/aquassist-shared/constants/types/flowMeters';
import { BOILER } from '../../../../aquassist-shared/constants/types/components';

export default {
    name: 'AnalysisForm',
    components: {
        VAutocomplete,
        VSelect,
    },
    props: {
        mutableValue: {
            type: Object,
            default: null,
        },
        massBalanceSelected: {
            type: Object,
            default: null,
        },
        analysisSelection: {
            type: Array,
            default: () => {},
        },
        selection: {
            type: Array,
            default: () => {},
        },
        massBalanceType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isModeEdit: false,
            selectedAnalisysType: [],
            show: {},
            data: {},
            listNetwork: {},
            listComponentByNetwork: {},
            allFlowMeterType: [],
            sectionShow: {},
            debouncedAnalysisComponent: debounce(this.getAnalysisComponent, 300),
        };
    },
    computed: {
        ...mapGetters([
            'team',
            'userLang',
            'massBalanceData',
            'site',
        ]),
        TYPE_STEAM() {
            return TYPE_STEAM;
        },
        BOILER() {
            return BOILER;
        },
        NONE() {
            return NONE;
        },
        STEAM() {
            return STEAM;
        },
        analysisSections() {
            return this.massBalanceType === COOLING ? [NONE] : [MAKEUP_PERCENTAGE, CYCLES_OF_CONCENTRATION];
        },
        finalisedAnalysisSelection() {
            return {
                [MAKEUP_PERCENTAGE]: this.analysisSelection.map(analysisType => ({ ...analysisType, section: MAKEUP_PERCENTAGE })),
                [CYCLES_OF_CONCENTRATION]: this.analysisSelection.map(analysisType => ({ ...analysisType, section: CYCLES_OF_CONCENTRATION })),
                [NONE]: this.analysisSelection.map(analysisType => ({ ...analysisType, section: NONE })),
            };
        },
    },
    watch: {
        selectedAnalisysType() {
            return this.onInput();
        },
    },
    created() {
        this.allFlowMeterType = this.selection.map(flowType => (
            {
                type: flowType.toUpperCase(),
            }
        ));
        this.initFlowmeterSelection();
        this.unsubscribe = this.$store.subscribe(mutation => {
            if (mutation.type === 'setFlowmeterNetwork') {
                this.initFlowmeterSelection();
            }
            if (mutation.type === ' resetMassBalanceData') {
                this.selectedAnalisysType = [];
            }
        });
    },
    mounted() {
        this.emitChange();
    },
    beforeDestroy() {
        this.unsubscribe();
    },
    methods: {
        ...mapActions({
            setanalysis: 'setanalysis',
        }),
        isIncludeAnalysisSelected(selectedAnalysis) {
            return this.selectedAnalisysType.some(type => type.id === selectedAnalysis.id);
        },
        isSectionValid(section) {
            return this.selectedAnalisysType.some(anal => anal.section === section);
        },
        initFlowmeterSelection() {
            this.isModeEdit = !isEmpty(this.massBalanceSelected);
            this.analysisSections.forEach(section => {
                this.allFlowMeterType.forEach(flowmeter => {
                    this.finalisedAnalysisSelection[section].forEach(analysisSelec => {
                        let config = [
                            {
                                networkId: '',
                                componentIds: [],
                            },
                        ];
                        if (this.isModeEdit) {
                            const matchedAnalysis = this.massBalanceSelected.analysis
                                .find(t => t.analysisIds
                                    .some(analId => analId.id === analysisSelec.id && analId.section === section)
                               && flowmeter.type === t.type);
                            if (matchedAnalysis) {
                                this.selectedAnalisysType.push(analysisSelec);
                                config = matchedAnalysis.config;
                                config.forEach(c => {
                                    this.getAnalysisComponent(c, analysisSelec, flowmeter);
                                });
                            } else {
                                config = undefined;
                            }
                        }
                        const oldFlowmeterDataType = this.data[flowmeter.type] || {};
                        const oldConfig = oldFlowmeterDataType[analysisSelec.key];
                        this.data[flowmeter.type] = {
                            ...this.data[flowmeter.type],
                            [analysisSelec.key]: config ? cloneDeep(config) : oldConfig ?? [
                                {
                                    networkId: '',
                                    componentIds: [],
                                },
                            ],
                        };
                        const key = this.getKey(flowmeter, analysisSelec);
                        this.show[key] = true;
                        this.listNetwork[key] = [];
                        this.listComponentByNetwork[key] = {};
                    });
                });
            });
            this.getNetworkByFlowmeter();
        },
        showData(flowmeter, analysis) {
            const key = this.getKey(flowmeter, analysis);
            this.show = {
                ...this.show,
                [key]: !this.show[key],
            };
        },
        addReportData(analysisKey, floType) {
            this.data = {
                ...this.data,
                [floType]: {
                    ...this.data[floType],
                    [analysisKey]: [...this.data[floType][analysisKey], {
                        networkId: '',
                        componentIds: [],
                    }],
                },
            };
            this.emitChange();
        },
        removeReportData(analysisKey, floType, index) {
            const analysis = cloneDeep(this.data[floType][analysisKey]);
            analysis.splice(index, 1);
            this.data = {
                ...this.data,
                [floType]: {
                    ...this.data[floType],
                    [analysisKey]: analysis,
                },
            };
            this.emitChange();
        },
        getAvailableNetworks(flowmeter, analysis, networkId) {
            const key = this.getKey(flowmeter, analysis);
            const selectedNetworks = this.data[flowmeter.type][analysis.key].map(s => s.networkId);
            const availableNetworks = this.listNetwork[key].filter(s => !selectedNetworks.includes(s.id));
            const selectedNetwork = this.listNetwork[key].find(s => s.id === networkId);
            if (networkId) {
                availableNetworks.push(selectedNetwork);
            }
            return availableNetworks;
        },
        getNetworkByFlowmeter() {
            const { allNetworks } = this.massBalanceData.flowMeters;
            this.allFlowMeterType.forEach(flo => {
                this.analysisSelection.forEach(analysisSelec => {
                    this.listNetwork = {
                        ...this.listNetwork,
                        [this.getKey(flo, analysisSelec)]: allNetworks,
                    };
                });
            });
        },
        async getAnalysisComponent(config, analysisType, flowMeter) {
            const key = this.getKey(flowMeter, analysisType);
            const { data: analysis } = await this.$rq.getMassBalanceAnalysisByComponents(this.site.id, config.networkId, analysisType.id);
            this.listComponentByNetwork = {
                ...this.listComponentByNetwork,
                [key]: {
                    ...this.listComponentByNetwork[key],
                    [config.networkId]: analysis.map(p => ({
                        name: p.name,
                        id: p.id,
                    })),
                },
            };
            this.onInput();
        },
        getKey(flowMeter, analysisType) {
            return `${flowMeter.type}_${analysisType.key}`;
        },
        validateAnalysis() {
            let isValid = this.allFlowMeterType.length > 0 && this.selectedAnalisysType.length > 0;
            if (this.massBalanceType === STEAM) {
                const hasMackUpPercentage = this.selectedAnalisysType.find(s => s.section === MAKEUP_PERCENTAGE);
                const hasConcentrationCycle = this.selectedAnalisysType.find(s => s.section === CYCLES_OF_CONCENTRATION);
                isValid = isValid && !!hasMackUpPercentage && !!hasConcentrationCycle;
            }
            if (this.sectionShow) {
                Object.keys(this.sectionShow).forEach(key => {
                    const [flowType, typeKey] = key.split('_');
                    const configData = this.data[flowType]?.[typeKey];
                    configData.forEach(v => {
                        isValid = isValid && !!v.networkId && v.componentIds.length > 0;
                    });
                });
            }
            return isValid;
        },
        emitChange() {
            this.onInput();
            this.$emit('inputChange', this.validateAnalysis);
        },
        onInput() {
            this.sectionShow = {};
            const analysisData = [];
            const summaryData = [];
            this.allFlowMeterType.forEach(f => {
                this.selectedAnalisysType.forEach(s => {
                    const key = this.getKey(f, s);
                    analysisData.push({
                        type: f.type,
                        analysisIds: [{
                            id: s.id,
                            key,
                            section: s.section,
                        }],
                        config: this.data[f.type][s.key],
                    });
                });
            });
            const newData = [];
            analysisData.forEach(data => {
                const { type, config } = data;

                // Fonction pour ajouter des analysisIds
                const addAnalysisId = (id, section) => {
                    const existing = newData.find(item => item.type === type && item.analysisIds.some(i => i.id === id));
                    if (existing) {
                        // Push new analysisIds if not already included
                        if (!existing.analysisIds.some(newAnalysisIds => newAnalysisIds.id === id && newAnalysisIds.section === section)) {
                            existing.analysisIds.push({ id, section });
                        }
                    } else {
                        newData.push({
                            type,
                            analysisIds: [{ id, section }],
                            config,
                        });
                    }
                };

                // Boucle sur les analysisIds
                data.analysisIds.forEach(oneAnalysisIds => {
                    const { id, section, key } = oneAnalysisIds;
                    if (type === TYPE_MAKE_UP.toUpperCase() && section === MAKEUP_PERCENTAGE) {
                        this.sectionShow[key] = true;
                        addAnalysisId(id, section);
                    } else if (type === TYPE_STEAM.toUpperCase() && section === CYCLES_OF_CONCENTRATION) {
                        this.sectionShow[key] = true;
                        addAnalysisId(id, section);
                    } else if (type === TYPE_FEED.toUpperCase() || section === NONE) {
                        this.sectionShow[key] = true;
                        addAnalysisId(id, section);
                    }
                });
            });
            if (this.sectionShow) {
                Object.keys(this.sectionShow).forEach(key => {
                    const [flowType, typeKey] = key.split('_');
                    const analysisType = this.selectedAnalisysType.find(s => s.key === typeKey);
                    summaryData.push({
                        type: flowType,
                        name: [analysisType.name].pop(),
                        measureUnit: [analysisType.measureUnit].pop(),
                        key: typeKey,
                        config: this.data[flowType][typeKey].map(p => {
                            const network = this.listNetwork[key].find(n => n.id === p.networkId);
                            const component = Object.values(this.listComponentByNetwork[key])
                                .flat()
                                .filter(t => p.componentIds.includes(t.id));
                            return { network, component };
                        }),
                    });
                });
            }
            this.setanalysis({ analysis: { newData, summaryData } });
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
</style>
